export default __webpack_public_path__ + "static/media/certificado-semana-vm.e71fc674.svg";